module.exports = __webpack_public_path__ + "8a9c0dcb018558f10a07c709c910fdf5.MP3";